import ReactApexChart from "react-apexcharts";

function LineChart(props) {
  let no_messages = props.no_messages;
  no_messages = new Map([...no_messages.entries()].sort());
  
  const xAxis = Array.from(no_messages.keys());

  let unique_sess = props.unique_sess;
  unique_sess = new Map([...unique_sess.entries()].sort());

  let unique_users = props.unique_num;
  unique_users = new Map([...unique_users.entries()].sort());


  const yAxis_users = Array.from(unique_users.values());
  const yAxis_sessions = Array.from(unique_sess.values());

  let e = 0;

  e = 0;
  for(let i=0; i<xAxis.length; i++){
    if(xAxis.at(i + e) != Array.from(unique_users.keys()).at(i)){
      yAxis_users.splice(i, 0, 0);
      e++;
    }
  }

  const yAxis = Array.from(no_messages.values());
  
  const chartOptions = {
    xaxis: {
      categories: xAxis,
      labels: {
        style: {
          colors: '#000000', // X-axis label color
        },
      },
      axisBorder: {
        show: true,
        color: '#000000', // X-axis border color
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return value;
        },
      },
      labels: {
        style: {
          colors: '#000000', // X-axis label color
        },
      },
      axisBorder: {
        show: true,
        color: '#000000', // X-axis border color
      },
    },
    title: {
      text: 'Message Utility',
      align: 'left',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontWeight: 'bold',
        color: '#000000',
        fontSize: '20px', // Adjust the font size as needed
        fontFamily: 'Helvetica, Arial, sans-serif', // Set to Helvetica and fallback to Arial and generic sans-serif
      },
    },
    legend: {
      show: true,
      position: "bottom",
      labels: {
        colors: '#000000', // Set the font color for the legend text
        fontSize: "12px"
      },
    },
    fill: {
      type: 'gradient', // You can use 'solid' for a solid color fill
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.3,
        opacityTo: 0.9,
        stops: [0, 100],
      }
    },
    
  };

  const chartSeries = [
    {
      name: "Messages",
      type: 'area', // Use 'area' type to shade the area under the line
      data: yAxis,
      color: "#007500", // Color for the combined line
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.7,
          stops: [0, 5],
        }
      }
    },
    {
      name: 'Unique Users',
      type: 'area',
      data: yAxis_users,
      color: '#FFD700',
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.2,
          stops: [0, 100],
        }
      }
    },
    {
      name: 'Unique Sessions',
      type: 'area',
      data: yAxis_sessions,
      color: '#AC8F00',
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.7,
          stops: [0, 100],
        }
      }
    },
  ];

  return (
    <>
      <ReactApexChart
        className="full-width"
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={415}
        width={"100%"}
      />
    </>
  );
}

export default LineChart;



